import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

const ReportSummaryCards = ({ totalYearlySales, totalYearlyExpenses, totalStaffWork }) => {
  const theme = useTheme();
  const iconSx = {
    position: 'absolute',
    top: 16,
    right: 16,
    fontSize: '4rem',
    color: 'rgba(255, 255, 255, 0.3)',
  };

  return (
    <Grid container spacing={3} mb={3}>
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <CardContent>
            <Typography variant="h6" color="inherit">
              Total Yearly Sales
            </Typography>
            <Typography variant="h4" color="inherit" sx={{ mt: 1 }}>
              ₹{totalYearlySales.toFixed(2)}
            </Typography>
            <MonetizationOnOutlinedIcon sx={iconSx} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <CardContent>
            <Typography variant="h6" color="inherit">
              Total Yearly Expenses
            </Typography>
            <Typography variant="h4" color="inherit" sx={{ mt: 1 }}>
              ₹{totalYearlyExpenses.toFixed(2)}
            </Typography>
            <ShoppingCartOutlinedIcon sx={iconSx} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <CardContent>
            <Typography variant="h6" color="inherit">
              Total Staff Work
            </Typography>
            <Typography variant="h4" color="inherit" sx={{ mt: 1 }}>
              ₹{totalStaffWork.toFixed(2)}
            </Typography>
            <GroupsOutlinedIcon sx={iconSx} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ReportSummaryCards;